// let imgBase='https://ssy.kamlung.net/images/hongqi/'
// import { activityTime } from '@/utils/utils'
export let imgBase = 'https://img.kamlung.net/icaur/'

export let imgBase2 = 'https://img.kamlung.net/icaurImg/'
// export let imgBase = `${process.env.VUE_APP_URL}/images/icaur/`


export let contactList = [
    {
        id: 1,
        img: 'https://img.kamlung.net/hk/hongqi-contact/1.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1953,
    },
    {
        id: 2,
        img: 'https://img.kamlung.net/hk/hongqi-contact/2.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1958,
    },
    {
        id: 3,
        img: 'https://img.kamlung.net/hk/hongqi-contact/3.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1960,
    },
    {
        id: 4,
        img: 'https://img.kamlung.net/hk/hongqi-contact/4.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1966,
    },
    {
        id: 5,
        img: 'https://img.kamlung.net/hk/hongqi-contact/5.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1978,
    },
    {
        id: 6,
        img: 'https://img.kamlung.net/hk/hongqi-contact/6.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2018,
    },
    {
        id: 7,
        img: 'https://img.kamlung.net/hk/hongqi-contact/7.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2019,
    },
    {
        id: 8,
        img: 'https://img.kamlung.net/hk/hongqi-contact/8.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2020,
    },
    {
        id: 9,
        img: 'https://img.kamlung.net/hk/hongqi-contact/9.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2022,
    },
    {
        id: 10,
        img: 'https://img.kamlung.net/hk/hongqi-contact/10.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2023,
    },
    {
        id: 11,
        img: 'https://img.kamlung.net/hk/hongqi-contact/11.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2026,
    },
]
export let contactImgList = [
    'https://img.kamlung.net/hk/hongqi-contact/1.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/2.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/3.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/4.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/5.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/6.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/7.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/8.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/9.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/10.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/11.jpg',
]



// export let information = [
//     {
//         id: 1,
//         img: require('@/assets/img/information/1.jpg'),
//         title: '家庭新硬派iCAR V27正式上市，售价16.98万元起',
//         createTime: activityTime(new Date())
//     },
//     {
//         id: 2,
//         img: require('@/assets/img/information/2.png'),
//         title: '全能硬派，全家都爱！iCAR V27广州车展中国首秀',
//         createTime: activityTime(new Date())
//     },
//     {
//         id: 3,
//         img: require('@/assets/img/information/3.png'),
//         title: '性能天花板，驾趣新标杆！iCAR全新超级V23重磅上市，售价12.28万元起',
//         createTime: activityTime(new Date())
//     },
//     {
//         id: 4,
//         img: require('@/assets/img/information/4.jpg'),
//         title: '天生会玩！iCAR V23广州车展开启预售，宠粉价11万-15万元',
//         createTime: activityTime(new Date())
//     },
//     {
//         id: 5,
//         img: require('@/assets/img/information/5.jpg'),
//         title: 'iCAR 品牌升维，携V23亮相品牌之夜，年轻人的梦想座驾年底上市',
//         createTime: activityTime(new Date())
//     }
// ]


export let detailNvgList = [
    // {
    //     id: 1,
    //     idN: 'showroom',
    //     label: '3D Showroom',
    // },
    {
        id: 2,
        idN: 'highlights',
        label: 'MODEL Highlights',
        lang: 'public.highlights'
    },
    {
        id: 3,
        idN: 'specifications',
        label: 'Specifications',
        lang: 'public.parameters'
    },
    {
        id: 4,
        idN: 'exterior',
        label: 'Exterior Details',
        lang: 'public.exterior'
    },
    {
        id: 5,
        idN: 'Interior',
        label: 'Interior',
        lang: 'public.Interior'
    },
    {
        id: 6,
        idN: 'video',
        label: 'video',
        lang: 'public.video'
    },
    {
        id: 7,
        idN: 'gallery',
        label: 'Gallery',
        lang: 'public.gallery'
    },

    // {
    //     id: 5,
    //     idN: 'TEST',
    //     label: 'TEST DRIVE',
    // },
    // {
    //     id: 6,
    //     idN: 'manual',
    //     label: 'service manual',
    // },
]

export const carConfigData = [
    {
        name: "Executive",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 84,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+160",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+300",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥380",
            },
        ],
    },
    {
        name: "Deluxe",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 99,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+245",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+450",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥441",
            },
        ],
    },
    {
        name: "Flagship",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 99,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+245",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+450",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥441",
            },
        ],
    },
    {
        name: "Long Range",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 99,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+245",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+450",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥515",
            },
        ],
    },
]


// export const carList = [
//     {
//         "id": 1,
//         "modelName": "iCAR V27",
//         "exterior": [
//             {
//                 "id": 1,
//                 "front_45_side": require('@/assets/img/car/V27/1.png'),
//                 "front_color": "color-orange",
//                 "color": "橙",
//             },
//             {
//                 "id": 2,
//                 "front_45_side": require('@/assets/img/car/V27/2.png'),
//                 "front_color": "color-silver",
//                 "color": "银",
//             },
//             {
//                 "id": 3,
//                 "front_45_side": require('@/assets/img/car/V27/3.png'),
//                 "front_color": "color-green",
//                 "color": "灰",
//             },
//             {
//                 "id": 4,
//                 "front_45_side": require('@/assets/img/car/V27/4.png'),
//                 "front_color": "color-white",
//                 "color": "白",
//             },
//             {
//                 "id": 5,
//                 "front_45_side": require('@/assets/img/car/V27/5.png'),
//                 "front_color": "color-black",
//                 "color": "黑",
//             },
//             {
//                 "id": 6,
//                 "front_45_side": require('@/assets/img/car/V27/6.png'),
//                 "front_color": "color-blue",
//                 "color": "蓝",
//             },
//         ],
//     },
//     {
//         "id": 2,
//         "modelName": "全新超级V23",
//         "exterior": [
//             {
//                 "id": 1,
//                 "front_45_side": require('@/assets/img/car/V23/1.webp'),
//                 "front_color": "color-orange",
//                 "color": "橙",
//             },
//             {
//                 "id": 2,
//                 "front_45_side": require('@/assets/img/car/V23/2.webp'),
//                 "front_color": "color-silver",
//                 "color": "银",
//             },
//             {
//                 "id": 3,
//                 "front_45_side": require('@/assets/img/car/V23/3.webp'),
//                 "front_color": "color-green",
//                 "color": "灰",
//             },
//             {
//                 "id": 4,
//                 "front_45_side": require('@/assets/img/car/V23/4.webp'),
//                 "front_color": "color-white",
//                 "color": "白",
//             },
//             {
//                 "id": 5,
//                 "front_45_side": require('@/assets/img/car/V23/5.webp'),
//                 "front_color": "color-black",
//                 "color": "黑",
//             },
//             {
//                 "id": 6,
//                 "front_45_side": require('@/assets/img/car/V23/6.webp'),
//                 "front_color": "color-purple",
//                 "color": "紫",
//             },
//         ],
//     },
//     {
//         "id": 3,
//         "modelName": "全新超级V23S",
//         "exterior": [
//             {
//                 "id": 1,
//                 "front_45_side": require('@/assets/img/car/V23S/1.png'),
//                 "front_color": "color-orange",
//                 "color": "橙",
//             },
//             {
//                 "id": 2,
//                 "front_45_side": require('@/assets/img/car/V23S/2.png'),
//                 "front_color": "color-silver",
//                 "color": "银",
//             },
//             {
//                 "id": 3,
//                 "front_45_side": require('@/assets/img/car/V23S/3.png'),
//                 "front_color": "color-green",
//                 "color": "绿",
//             },
//             {
//                 "id": 4,
//                 "front_45_side": require('@/assets/img/car/V23S/4.png'),
//                 "front_color": "color-white",
//                 "color": "白",
//             },
//             {
//                 "id": 5,
//                 "front_45_side": require('@/assets/img/car/V23S/5.png'),
//                 "front_color": "color-black",
//                 "color": "黑",
//             },
//             {
//                 "id": 6,
//                 "front_45_side": require('@/assets/img/car/V23S/6.png'),
//                 "front_color": "color-purple",
//                 "color": "紫",
//             },
//             {
//                 "id": 7,
//                 "front_45_side": require('@/assets/img/car/V23S/7.png'),
//                 "front_color": "color-blue",
//                 "color": "蓝",
//             },
//             {
//                 "id": 8,
//                 "front_45_side": require('@/assets/img/car/V23S/8.png'),
//                 "front_color": "color-gray",
//                 "color": "灰",
//             },
//             {
//                 "id": 9,
//                 "front_45_side": require('@/assets/img/car/V23S/9.png'),
//                 "front_color": "color-yellow",
//                 "color": "黄",
//             },
//         ],
//     },
//     {
//         "id": 4,
//         "modelName": "全新超级V23赛博版",
//         "exterior": [
//             {
//                 "id": 1,
//                 "front_45_side": require('@/assets/img/car/V23sb/1.webp'),
//                 "front_color": "color-silver",
//                 "color": "哑光银",
//             },
//             {
//                 "id": 2,
//                 "front_45_side": require('@/assets/img/car/V23sb/2.webp'),
//                 "front_color": "color-gray",
//                 "color": "星夜灰",
//             },
//         ],
//     },
// ]

export const colorList = [
]





export const newsDetail = `<div data-v-2c734203="" class="detail-content"><p><span style="font-family: Arial;">3月13日，家庭新硬派iCAR V27正式上市，共推出三个配置车型：210</span>KM两<span style="font-family: Arial;">驱猎鹰500版，指导价16.98万元；200</span>KM<span style="font-family: Arial;">四驱猎鹰500版，指导价18.28万元；200</span>KM<span style="font-family: Arial;">四驱猎鹰700版，指导价19.68万元。V27以高颜值大空间、第一梯队辅助驾驶、超级黄金增程动力、新硬派标杆操控、超强生态拓展等越级体验，为先锋家庭与个性玩家带来全能价值和超高向往感。</span></p><p><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314100904_57.jpg" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">上市期间，iCAR V27 推出限时7重购车权益，5月31日前下定用户即可享受：至高8700元的零税购车礼、至高6000元的焕新置换礼、价值4000元的智能安心礼、价值20000元的舒适野趣礼，以及免费送充电桩及安装、终身娱乐流量免费（10G/月）、无忧服务礼，权益丰厚实用，全面降低家庭购车与用车成本，凸显家庭新硬派高性价比优势。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314100931_58.jpg" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">iCAR坚持只造特色车，V27以全能实力重塑家用SUV的体验边界，让个性驾趣与家庭实用二者兼得。在发布会上，iCAR品牌事业部总经理苏峻博士表示：“打造iCAR V27的原点就是一句话：‘父母的大玩具，孩子的游乐场’。凭借高颜值大空间，标杆增程性能，标杆公路操控，标杆泛越野实力，标杆智能辅助驾驶和标杆生态，V27必定成为全家都爱的全能硬派！”</span></p><p style="text-align: left;"><strong>高颜值大空间，全家舒享新境界</strong></p><p style="text-align: left;"><span style="font-family: Arial;">iCAR V27采用未来经典设计理念，融合经典越野姿态与精致科技，在秩序与简洁中凸显独特风格。车身超5米，搭配近1:1宽高比、直立A柱，姿态挺拔，勾勒硬派风格比例，超低窗线与高占比侧窗，营造通透视野。高集成度科技岛，在极简中透出科技精致，打造出穿越周期的经典美学。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314102402_59.png" alt="" data-href="" style=""></p><p><span style="font-family: Arial;">V27内饰以“星舰座舱”为设计核心，将未来科技融入硬派美学。同级首创“星际舷窗”双天幕，夹层玻璃紫外线隔绝率99.9%，“天空岛”顶棚集成氛围灯和拓展功能，兼具美观与实用性。超高坐姿的前排指令长座椅，采用10层复合结构，柔软承托缓解驾乘疲惫。</span></p><p><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314104249_68.png" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">针对家庭出行需求，V27打造极致通透大空间，车内最高1350mm超高挑空，告别旅途局促。后排座椅放倒后形成1818L方正空间，搭配定制床垫秒变2150×1050mm大床，全家出行可轻松躺平。此外，全车多达50处的储物空间，更让每位家庭成员的小物件，都能妥帖安放。</span></p><p style="text-align: left;"><strong>超级黄金增程，新硬派标杆操控，最好开的5米级方盒子</strong></p><p style="text-align: left;"><span style="font-family: Arial;">V27搭载超级黄金增程系统，基于奇瑞1.5T中国心十佳增程专用发动机打造，热效率高达45.79%，实现1L油发3.71度电极致效率。首发搭载34.3kWh宁德时代磷酸铁锂电池，30%-80%快充时间仅需17分钟，纯电续航200km+、综合续航1200km+。V27四驱版电驱总功率335kW（455匹），峰值扭矩505N·m，零百加速5秒级，</span>馈<span style="font-family: Arial;">电状态下也能保持140km/h稳定巡航，澎湃动力时刻在线。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314103442_61.jpg" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">依托i-SWIFT雨燕平台2.0架构，V27拥有同级领先的轻量化车身，搭配四轮四角布局，运动跑车同源的MRC磁霸悬架系统，经由国际知名浦罗迪夫团队大师级深度调校，让5米大车也有灵活驾控。新车还配备8+X全路况驾驶模式，在i-AWD鬣蜥四驱系统的强大脱困能力加持下，实现全地形随心掌控。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314103509_62.jpg" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">在强大动力与泛越野实力基础上，iCAR V27成功穿越塔克拉玛干沙漠N39线，更斩获中汽研L3级别越野认证，证明了全路况皆驾驭的全能实力。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314103543_63.jpg" alt="" data-href="" style=""></p><p style="text-align: left;"><strong>辅助驾驶第一梯队，家庭出行安心更可靠</strong></p><p><span style="font-family: Arial;">辅助驾驶体验上，V27实现了从“有”到“好用”的全面进阶。V27以第一梯队辅助驾驶实力，让全家出行更轻松、更安心。超级猎鹰700+辅助驾驶系统，搭载算力高达560TOPS的地平线征程6P芯片+HSD领先算法，配合27颗高精传感器，使辅助驾驶系统真正实现“有路就能开、五年不过时”。</span></p><p><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314103615_64.jpg" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">基于地平线HSD一段式端到端架构+云端VLM+强化学习算法，V27可实现不依赖高精地图的全场景城市/高速领航NOA、漫游模式与智能泊车功能。系统经过海量“国宾级司机”驾驶数据训练，具备超前预判、超低时延、防御性驾驶等能力，能够在复杂交通环境中从容博弈、高度拟人，兼顾安全与效率。</span></p><p style="text-align: left;"><span style="font-family: Arial;">在丽江、重庆、北京等地的复杂路况实测中，V27</span>的辅助驾驶系统<span style="font-family: Arial;">无论是面对大曲率高架桥，还是人车混杂的市井窄巷，都能像经验丰富的“老司机”一般，变道、绕行、博弈行云流水，带来“真人感、超丝滑”的体验。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314103736_65.png" alt="" data-href="" style=""></p><p style="text-align: left;"><span style="font-family: Arial;">不止全场景、全天候的智能陪伴，V27更以磐石车身打造全方位的安全防护，基于中欧双五星安全标准设计，采用11横11纵磐石笼式车身，整车高强度钢占比高达76.53%，标配7气囊，最大限度地保护座舱内的每一位成员。</span></p><p style="text-align: left;"><strong>全维生态随心拓展，全家出行更有趣</strong></p><p style="text-align: left;"><span style="font-family: Arial;">生态布局上，V27实现软硬件全方位突破，打造真正的全家出行生态体系。改装拓展方面，V27全车配备17处51个生态接口，四驱版限时赠送拖车套装 （1.6T拖挂资质+拖车钩+拖车电源取电口），轻松满足户外探索的各类拓展需求。座舱生态方面，V27智能座舱集成生态坞APP、智家APP，可集中控制车内儿童安全座椅、冷暖冰箱等定制配件，此外还可实现车与智能家电的跨平台互控，智能联结人-车-家。与此同时，iCAR品牌与牧高笛、Yakima等户外品牌共创定制产品，并携手《中国国家地理》推出专享科考、亲子秘境旅行，让V27不止于车，更是探索世界的伙伴。</span></p><p style="text-align: left;"><img src="https://cdn-cms.icarglobal.com/platform/public/image/20260314/20260314103801_66.jpg" alt="" data-href="" style=""></p><p><span style="font-family: Arial;">全能硬派，全家都爱！iCAR V27凭借其在设计、空间、驾控、智能及生态维度的全面越级，重塑新能源方盒子价值标杆，精准回应家庭用户对美好出行的向往。未来，iCAR将用持续的特色产品与多元生态，为全球用户缔造更具乐趣的差异化出行新选择。</span></p></div>`